import instance from "../../utils/axios";

// 🔹 Fetch Bulletins (if needed later)
export const fetchBulletins = async (_id) => {
  const formData = new URLSearchParams();
  if (_id) formData.append("_id", _id);

  const response = await instance.post("/churches/bulletin/read", formData);
  return response.data;
};

// 🔹 Save Bulletin
export const saveBulletin = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => formData.append(key, val || ""));
  const response = await instance.post("/churches/bulletin/save", formData);
  return response.data;
};

// 🔹 Update Bulletin
export const updateBulletin = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => formData.append(key, val || ""));
  const response = await instance.post("/churches/bulletin/update", formData);
  return response.data;
};

// 🔹 Delete Bulletin
export const deleteBulletin = async (payload) => {
  const formData = new URLSearchParams();
  formData.append("_id", payload._id || "");
  formData.append("bulletinObjId", payload.bulletinObjId || "");
  const response = await instance.post("/churches/bulletin/delete", formData);
  return response.data;
};
